export default "__VITE_ASSET__WqAQLGnL__"